import { chooseBestFit, extractSizes } from 'wordpress/components'
import '../styles/FindAndBook.scss'

// First item in the gallery must be image, otherwise there will be gray background
// until the video is loaded and the video will only play for 20 seconds.
// Two videos should not be adjacent, because current implementation uses the image
// before the video as background until the video is loaded.

const PHOTO_DISPLAY_TIME = 15000

const Gallery = ({ gallery }) => {
    if (!gallery || gallery.length === 0) return null

    const [currentBackgroundIndex, setCurrentBackgroundIndex] = React.useState(0)
    const timerRef = React.useRef(null)

    React.useEffect(
        () => () => {
            clearTimeout(timerRef.current)
        },
        []
    )

    React.useEffect(() => {
        if (!isNextItemVideo) timerRef.current = setTimeout(setNextBackground, PHOTO_DISPLAY_TIME)
    }, [currentBackgroundIndex])

    const [nextItem, nextIndex, isNextItemVideo] = React.useMemo(() => {
        const nextIndex = currentBackgroundIndex === gallery.length - 1 ? 0 : currentBackgroundIndex + 1
        const nextItem = gallery[nextIndex]
        const isVideo = nextItem.type === 'video'
        return [nextItem, nextIndex, isVideo]
    }, [currentBackgroundIndex])

    const [currentItem, isCurrentItemVideo] = React.useMemo(() => {
        const currentItem = gallery[currentBackgroundIndex]
        const isCurrentItemVideo = currentItem.type === 'video'
        return [currentItem, isCurrentItemVideo]
    }, [currentBackgroundIndex])

    const imageUrl = React.useMemo(
        () => (isCurrentItemVideo ? chooseBestFit(extractSizes(nextItem)) : chooseBestFit(extractSizes(currentItem))),
        [currentBackgroundIndex]
    )

    const videoUrl = React.useMemo(() => (isCurrentItemVideo ? currentItem.url : false), [currentBackgroundIndex])

    const setNextBackground = () => {
        setCurrentBackgroundIndex(nextIndex)
    }

    return (
        <div className="background" style={{ backgroundImage: `url(${imageUrl})` }}>
            {videoUrl && (
                <video src={videoUrl} autoPlay muted playsInline onEnded={setNextBackground}>
                    Your browser does not support the video tag.
                </video>
            )}
        </div>
    )
}

export default Gallery
